import { render } from "./ProductRevenue.vue?vue&type=template&id=29d63bf4"
import script from "./ProductRevenue.vue?vue&type=script&lang=js"
export * from "./ProductRevenue.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__